
import React from 'react';
import GridTable from '../../components/GridTable';
import Layout from '../../components/Layout';
import { MODULES } from '../../utils/constants';
import AddCouponDialog from './AddCouponDialog';
import { getColumns } from './constants';
import { useCouponStore } from '../../services/coupons';
import { useCompanyStore } from '../../services/company';
import CouponUsageDialog from './CouponUsageDialog';
import { ICoupon } from '../../types/coupons';

const Coupons = () => {
    const {
        data,
        totalPages,
        currentPage,
        total,
        isLoading,
        fetchGrid,
        setFilters,
        onPageChange,
        onDelete,
        limit
    } = useCouponStore();
    const { globalCompanyId } = useCompanyStore();
    const [selectedCoupon, setSelectedCoupon] = React.useState<ICoupon | null>(null);

    React.useEffect(() => {
        if (!globalCompanyId || globalCompanyId === "general") {
            setFilters({ corporateId: 'general' });
        } else {
            setFilters({ corporateId: globalCompanyId });
        }
    }, [globalCompanyId]);

    return (
        <Layout appBarTitle="Coupons Management">
            <Layout.Header component={AddCouponDialog} props={{ module: MODULES.COUPON }} />
            <Layout.Body
                component={GridTable}
                props={{
                    data,
                    columns: getColumns(currentPage, limit, (coupon: ICoupon) => setSelectedCoupon(coupon)),
                    currentPage,
                    totalPages,
                    total,
                    loading: isLoading,
                    onPageChange,
                    module: MODULES.COUPON,
                    onDelete: (item: any) => onDelete(item._id),
                    rows: limit
                }}
            />
            <CouponUsageDialog
                open={Boolean(selectedCoupon)}
                coupon={selectedCoupon}
                onClose={() => setSelectedCoupon(null)}
            />
        </Layout>
    );
};

export default Coupons;
